module.exports = __webpack_public_path__ + "static/img/vip-declare-1@2x.86a0055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-declare-1@2x.png
// module id = 6O3I
// module chunks = 1